import React, { useContext } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import OpenPopupBtn from "../../../common/OpenPopupBtn";
import { Cases, btnName, modalsName } from "../../../constant";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { OpenModalCommonFunc } from "../../../utils";
import CardBuilderHeaderSection from "../../../common/cardBuilderHeaderSection";
import CommonPopup from "../../../Modals/commonPopup";
import DataCounterPopup from "./DataCounterPopup";

const DataCounter = () => {
  const { setAllPopupState, allPopupState } = useContext(
    ByteCardBuilderContext
  );
  return (
    <>
      <Col xl="12 box-col-6" md="12">
        <Card className="ecommerce-widget mt-4 cardHover">
          <CardBody className="support-ticket-font box-border-div">
            <Row>
              <div className="col-12">
                <CardBuilderHeaderSection name="Data Counter" />
              </div>
              <OpenPopupBtn
                openPopup={() =>
                  OpenModalCommonFunc(Cases.DATA_COUNTER, setAllPopupState)
                }
                name={btnName.DATA_COUNTER}
              />
            </Row>
          </CardBody>
        </Card>
      </Col>

      <CommonPopup
        open={allPopupState.dataCounterPopup}
        close={() =>
          OpenModalCommonFunc(Cases.DATA_COUNTER, setAllPopupState, false)
        }
        modalName={modalsName.DATA_COUNTER}
        modalCase={Cases.DATA_COUNTER}
        content={<DataCounterPopup />}
      />
    </>
  );
};

export default DataCounter;
